/**
 * Types
 */

export type Props<UnitType, PricingType, LimitType> = Readonly<{
  isEditing?: boolean;
  useFirstItemUnitType?: boolean;
  children: (
    props: InterestLevelChildrenProps<UnitType, PricingType, LimitType>
  ) => React.ReactElement<InterestLevelProps<UnitType, PricingType, LimitType>>[];
}>;

export type InterestLevelFormValues<UnitType, PricingType, LimitType> = {
  unitType: UnitType;
  // quantity used in place of dollars/percentage/shares until unitType is selected:
  quantity?: number | null;
  dollars?: number | null;
  percentage?: number | null;
  shares?: number | null;
  pricingType: PricingType;
  limitPrice?: number | null;
  realDemandDollars?: number | null;
  realDemandPercentage?: number | null;
  realDemandShares?: number | null;
  limitType?: LimitType | null;
  limitPercentage?: number | null;
};

export type InterestLevelProps<UnitType, PricingType, LimitType> = Readonly<{
  isEditing?: boolean;
  isSubmitting?: boolean;
  index: number;
  replace: (
    index: number,
    value: InterestLevelFormValues<UnitType, PricingType, LimitType>
  ) => void;
  remove: (index: number) => void;
}>;

export type FormValues<UnitType, PricingType, LimitType> = Readonly<{
  interestLevels: InterestLevelFormValues<UnitType, PricingType, LimitType>[];
}>;

export type InterestLevelChildrenProps<UnitType, PricingType, LimitType> = Omit<
  InterestLevelProps<UnitType, PricingType, LimitType>,
  'index'
> & { interestLevels: InterestLevelFormValues<UnitType, PricingType, LimitType>[] };

/**
 * Initial values
 */

export const emptyInterestLevel = {
  unitType: null,
  dollars: null,
  percentage: null,
  shares: null,
  pricingType: null,
  limitPrice: null,
  realDemandDollars: null,
  realDemandPercentage: null,
  realDemandShares: null,
  limitType: null,
  limitPercentage: null,
};
